<template>
    <div ref="learnDetail" id="learnDetail" :style="isGuest?'height:80%;width: 80%;max-width:800px;max-height:800px;overflow-y:auto':''" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
      <div v-if="loading" class="loadingAlert">
          <el-alert
              title="加载中"
              description="正在加载数据,这可能需要一些时间,请稍后..."
              type="warning"
              center
              show-icon
              :closable="false">
          </el-alert>
      </div>
      <div class="returnButtonBox" v-if="$root.isMob()&&$route.path!='/'" @click="$emit('return')">
        <i class="el-icon-back icon"></i>
      </div>

      <div :class="$root.isMob()?'closeBtn mob':'closeBtn'" v-if="isGuest">
        <i :class="$root.isMob()?'el-icon-close':'closeIcon el-icon-close'" @click="$emit('close')"></i>
      </div>
      
      <div class="title" v-if="!isGuest">
        <el-button v-if="!$root.isMob()" size="small" @click="$emit('return')"><i class="el-icon-back"></i>返回</el-button>
        <h2>课堂详情</h2>
      </div>
      <div class="content">
        <div class="title">{{ title }}</div>
        <el-alert
            v-if="isNoFull || isGuest"
            title="提醒"
            :description="isGuest?'当前为试看模式,观看完整视频/音频请先登录。':'当前为试看模式,观看完整视频/音频请联系运营平台。'"
            type="warning"
            left
            show-icon
            :closable="false">
        </el-alert>
        <video
            :src="iframeVideoUrl"
            controls
            controlsList="nodownload"
            autoplay
        ></video>
        <el-alert
            title="课堂简介"
            :description="remark"
            type="info"
            left
            show-icon
            :closable="false">
        </el-alert>

        <div class="linkVideo">
            <div class="title">
                相关课堂
            </div>
            <div class="list">
                <div class="item" v-for="item in linkVideos" :key="item.id" @click="getData(item.id)">
                    <div class="pic">
                        <img :src="API+item.cover_img" alt=""/>
                    </div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'learnDetail',
  props: {
    id: {
      type: Number,
      default: 0
    },
    isGuest:{
        type: Boolean,
        default: false
    }
  },
  watch:{
  },
  data() {
    return {
      loading:false,
      iframeVideoUrl:"",
      title:"",
      remark:"",
      isNoFull:true,
      API:window.config.api,
      linkVideos:[],
    }
  },
  methods: {
    async getData(id=null){
      this.loading = true;
      let data = null;
      if(id){
        data = await this.$root.getLearnDetail(id);
      }
      else{
        data = await this.$root.getLearnDetail(this.id);
      } 
      let linkVideos = await this.$root.getLearnList('',0,1,10,true);
      //排除自身项
      let newLinkVideos = [];
      linkVideos.data.forEach(element => {
        if(id&&element.id != id){
            newLinkVideos.push(element);
        }
        if(!id&&element.id != this.id){
            newLinkVideos.push(element);
        }
      });
      this.linkVideos = newLinkVideos;
      this.title = data.data.name;
      this.remark = data.data.remark;
      if(data.data.long_url != ""){
        this.isNoFull = false;
        this.iframeVideoUrl = this.API+data.data.long_url;
      }
      else{
        this.isNoFull = true;
        this.iframeVideoUrl = this.API+data.data.short_url;
      }
      this.loading = false;
      if(id&&(this.isGuest||this.isNoFull)){
        this.$refs.learnDetail.scrollTo({
          top:0,
          behavior:'smooth'
        });
      }

      if(id&&!this.isGuest){        
        document.getElementById('right').scrollTo({
          top:0,
          behavior:'smooth'
        });
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  beforeDestroy() {
  },
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/learnDetail.scss"></style>